import { Controller } from 'stimulus';

class NavigationController extends Controller {
  connect() {
    this.isOpen = false;
  }

  onToggleClick() {
    this.isOpen = !this.isOpen;

    this.toggleNavigation();
  }

  toggleNavigation() {
    document.querySelector('body').classList.toggle('nav-open', this.isOpen);
    this.navigationTarget.classList.toggle('is-open', this.isOpen);
    this.togglerTarget.setAttribute('aria-expanded', this.isOpen);
  }
}

NavigationController.targets = [
  'navigation',
  'toggler',
];

export default NavigationController;
